import { useEffect, useRef } from 'react';
import { featureFlags, media } from '../config/site';

export function HeroPhoto() {
  const artworkRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const artwork = artworkRef.current;
    const reducedMotion = typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const precisePointer = typeof window.matchMedia === 'function'
      && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!artwork || !featureFlags.motion || reducedMotion || !precisePointer) return undefined;

    const letters = [...artwork.querySelectorAll<HTMLElement>('[data-alex-letter]')];
    const depths = [0.5, 0.78, 0.62, 1];
    let frame = 0;
    let pointerX = 0;
    let pointerY = 0;

    const render = () => {
      letters.forEach((letter, index) => {
        const depth = depths[index] ?? 1;
        letter.style.setProperty('--alex-x', `${(pointerX * depth).toFixed(2)}px`);
        letter.style.setProperty('--alex-y', `${(pointerY * depth).toFixed(2)}px`);
      });
      frame = 0;
    };

    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(render);
    };

    const onPointerMove = (event: PointerEvent) => {
      const bounds = artwork.getBoundingClientRect();
      pointerX = Math.max(-8, Math.min(8, ((event.clientX - bounds.left) / bounds.width - 0.5) * 16));
      pointerY = Math.max(-8, Math.min(8, ((event.clientY - bounds.top) / bounds.height - 0.5) * 16));
      schedule();
    };

    const reset = () => {
      pointerX = 0;
      pointerY = 0;
      schedule();
    };

    artwork.addEventListener('pointermove', onPointerMove, { passive: true });
    artwork.addEventListener('pointerleave', reset);
    return () => {
      artwork.removeEventListener('pointermove', onPointerMove);
      artwork.removeEventListener('pointerleave', reset);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <div className="hero-artwork" ref={artworkRef} data-enter="artwork">
      <div className="alex-letters" aria-hidden="true">
        {'ALEX'.split('').map((letter) => <span key={letter} data-alex-letter={letter}>{letter}</span>)}
      </div>
      <picture className="hero-photo">
        <img
          src={media.heroPortrait.src}
          srcSet={media.heroPortrait.srcSet}
          sizes="(max-width: 767px) 90vw, 46vw"
          width={media.heroPortrait.width}
          height={media.heroPortrait.height}
          alt="Александр, ALEXADS"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
      </picture>
    </div>
  );
}
